import React, { useState } from 'react';
import './BudgetTool.css';
import Sidebar from './SideBar';
import UpdateEventDetails from './updateEventDetailsForm';
import { useNavigate } from "react-router-dom";



const UpdateBudgetTool = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();

  const handleSelectCategory = (category) => {
    setSelectedCategory(category);
  };

  const handleCloseEventDetails = () => {
    setSelectedCategory(null);
    navigate('/user-dashboard');

  };

  return (
    <div id="BudgetTool">

   
        <UpdateEventDetails category={selectedCategory} onClose={handleCloseEventDetails} />
      
    </div>
  );
};

export default UpdateBudgetTool;
